module.exports = __webpack_public_path__ + "static/media/unicred.543782a4.png";